module.exports = __webpack_public_path__ + "static/img/animales_03.3eac45d0.jpg";